module.exports = __webpack_public_path__ + "img/joe.f4efaccc.png";